import storageFactory from './storageFactory';

export default () => storageFactory('localStorage');
